import { UAParser } from 'ua-parser-js';

export function formatUserAgent(userAgent: string) {
  if (!userAgent) {
    return '-';
  }
  const device = UAParser(userAgent);
  const browser = device?.browser;
  const os = device?.os;
  const cleanVersion = browser?.version
    ?.replace(/\.0$/, '')
    ?.replace(/\.0$/, '')
    ?.replace(/\.0$/, '');
  return `${os?.name} - ${browser?.name} ${cleanVersion}`;
}

// export function parseCurrentUserAgent() {
//   const device = UAParser(window?.navigator.userAgent);
//   return device;
// }
